import { Projects } from '../../../api';
import { orderBy, reject, uniqBy } from 'lodash';

export const filterProjectList = async (entityRef, customerId) => {
  const projectList = await Projects.listProjects({ entityRef, customerId: customerId });
  const uniqueProjects = uniqBy(projectList, 'id');
  const filteredProjects = reject(uniqueProjects, { id: null });
  return orderBy(filteredProjects, ['id'], ['asc']);
};
